import * as React from 'react'

function SvgPlayerFullScreen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        d="M10.524 13.458a.88.88 0 01.073 1.162l-.073.083-3.874 3.875 3.912.003a.88.88 0 01.872.76l.008.12v.264a.88.88 0 01-.762.871l-.12.008-6.33-.007a.88.88 0 01-.88-.88l.005.093a.877.877 0 01-.032-.166l-.005-.087-.01-6.331c0-.448.333-.816.763-.874l.12-.008h.26a.88.88 0 01.872.76l.008.12.006 3.802L9.09 13.27a.88.88 0 011.163-.074l.083.074.187.187zm9.132-8.642a.864.864 0 01.095.3l.006.108.01 6.331a.882.882 0 01-.762.874l-.12.008h-.261a.88.88 0 01-.872-.76l-.008-.12-.005-3.562-3.515 3.516a.88.88 0 01-1.162.073l-.083-.073-.187-.187a.88.88 0 01-.074-1.163l.074-.083 3.873-3.874L12.48 6.2a.88.88 0 01-.871-.76l-.009-.12v-.264a.88.88 0 01.762-.871l.12-.008 6.33.007c.4 0 .737.267.844.632z"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default SvgPlayerFullScreen
